var map = {
	"./ADA.png": 633,
	"./BNB.png": 634,
	"./BTCB.png": 635,
	"./BUSD.svg": 636,
	"./DADA.png": 637,
	"./DBNB.png": 638,
	"./DBOT.png": 639,
	"./DBTC.png": 640,
	"./DDOT.png": 641,
	"./DETH.png": 642,
	"./DFYN.png": 643,
	"./DND.png": 644,
	"./DOT.png": 645,
	"./ETH.png": 646,
	"./FIREBIRD.svg": 647,
	"./IRON-logo.png": 648,
	"./IRON.png": 649,
	"./IRON_inverse.png": 650,
	"./QUICKSWAP_LOGO.png": 651,
	"./SPOOKY-logo.png": 652,
	"./SUSHISWAP.png": 653,
	"./TCR.png": 654,
	"./TITAN.png": 655,
	"./TUSD.png": 656,
	"./USDC.png": 657,
	"./USDT.png": 658,
	"./ad3.png": 659,
	"./arrow-down-blue.svg": 660,
	"./arrow-down-grey.svg": 661,
	"./arrow-right-white.png": 662,
	"./arrow-right.svg": 663,
	"./big_unicorn.png": 664,
	"./blue-loader.svg": 205,
	"./circle-grey.svg": 665,
	"./circle.svg": 666,
	"./coinbaseWalletIcon.svg": 333,
	"./comingsoon.png": 334,
	"./dropdown-blue.svg": 667,
	"./dropdown.svg": 668,
	"./dropup-blue.svg": 669,
	"./eco-iron.png": 670,
	"./ethereum-logo.png": 671,
	"./fantom-logo.png": 261,
	"./favicon.png": 335,
	"./fortmaticIcon.png": 336,
	"./icon-staking.svg": 672,
	"./l_bg.jpg": 337,
	"./link.svg": 673,
	"./magnifying-glass.svg": 674,
	"./matic.png": 675,
	"./menu.svg": 676,
	"./metamask.png": 338,
	"./no-farm.svg": 677,
	"./noise.png": 678,
	"./nova.png": 339,
	"./plus-blue.svg": 679,
	"./plus-grey.svg": 680,
	"./portisIcon.png": 340,
	"./pumpkin.png": 206,
	"./question-mark.svg": 681,
	"./question.svg": 682,
	"./scream.png": 683,
	"./spinner.svg": 684,
	"./spookyswap.png": 685,
	"./stake/bnb.png": 686,
	"./stake/dai.png": 687,
	"./stake/ethereum-logo.png": 688,
	"./stake/ftm.png": 689,
	"./stake/pumpkin.png": 690,
	"./stake/tomb.png": 691,
	"./stake/usdc.png": 692,
	"./stake/wftm.png": 693,
	"./token-list-logo.png": 694,
	"./token-list/lists-dark.png": 695,
	"./token-list/lists-light.png": 696,
	"./token-logo.png": 697,
	"./trustWallet.png": 698,
	"./walletConnectIcon.svg": 341,
	"./x.svg": 699,
	"./xl_uni.png": 700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 278;